var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createSectionSmart, getAllLayers, getSelectedSections, getSortedSectionsArray, } from 'pxc-editor-core/helpers/schema';
import Section from 'pxc-editor-core/entities/Section';
import { overridePageAction, overridePagesAction } from '@/actions/page';
import { createNewPage, createSection, getShieldsByGroupId } from '@/helpers';
import { createSnapshotThunk } from '@/actions';
import { AUTOFILL_MODE, COPY_MODE } from '@/constants';
import { AUTOFILL_PATTERN } from 'pxc-editor-core/constants';
import { generateListByPattern } from '@/helpers/autofill';
export var autoFillAndCopySectionsThunk = function (payload) {
    return function (dispatch, getState) {
        var mode = payload.mode, pattern = payload.pattern;
        var _a = getState().core, pages = _a.pages, pagesOrder = _a.pagesOrder, pagesSelection = _a.pagesSelection, sectionsSelection = _a.sectionsSelection, includeOtherContent = _a.includeOtherContent;
        if (!Object.keys(sectionsSelection).length) {
            return;
        }
        var _b = __read(pagesSelection, 1), currentPageUid = _b[0];
        var currentPage = pages[currentPageUid];
        var selectedSections = getSortedSectionsArray(getSelectedSections({
            sectionsSelection: sectionsSelection,
            page: currentPage,
        }));
        var _c = __read(selectedSections, 1), selectedSection = _c[0];
        var selectedSectionWithoutContent = Section.fromDict(selectedSection)
            .clearContent()
            .toDict();
        var content = getLabelsList({
            config: payload,
            section: selectedSection,
        });
        if (content.length > 0) {
            var contentQueue_1 = __spreadArray([], __read(content), false);
            var currentPageIndex = pagesOrder.findIndex(function (uid) { return uid === currentPageUid; });
            var restSelectedShieldSections_1 = getSelectedShieldSections({
                page: currentPage,
                selectedSection: selectedSection,
            });
            var selectedSectionContentSettings_1 = Section.getContentSettings(selectedSection);
            var layers = getAllLayers(selectedSection.id, pages);
            if (!layers.group)
                return;
            if (!layers.shield)
                return;
            dispatch(createSnapshotThunk());
            var groupId = layers.group.id;
            var curShield_1 = layers.shield;
            var curShieldId_1 = layers.shield.id;
            var modified_1 = {
                pages: {},
                pagesOrder: [],
                pageIndex: currentPageIndex,
                shieldsSelection: {},
                sectionsSelection: {},
            };
            switch (mode) {
                case AUTOFILL_MODE:
                case COPY_MODE: {
                    switch (pattern) {
                        case AUTOFILL_PATTERN.NEXT_CELL: {
                            if (selectedSections.length > 1) {
                                var sections = selectedSections.reduce(function (acc, item) {
                                    var _a;
                                    var value = contentQueue_1.shift();
                                    if (value) {
                                        return __assign(__assign({}, acc), (_a = {}, _a[item.id] = __assign(__assign(__assign({}, Section.resetContent(item)), selectedSectionContentSettings_1), value), _a));
                                    }
                                    return acc;
                                }, {});
                                dispatch(overridePageAction({
                                    page: __assign(__assign({}, currentPage), { sections: __assign(__assign({}, currentPage.sections), sections) }),
                                }));
                            }
                            else {
                                while (!!contentQueue_1.length) {
                                    var nextPageUid = pagesOrder[modified_1.pageIndex];
                                    var nextPage = !!nextPageUid
                                        ? pages[nextPageUid]
                                        : createNewPage();
                                    var nextPageGroupShields = Object.values(getShieldsByGroupId({ id: groupId, page: nextPage }));
                                    var curShieldIndex = nextPageGroupShields.findIndex(function (shield) { return shield.id === curShieldId_1; });
                                    var nextShields = curShieldIndex === -1
                                        ? nextPageGroupShields
                                        : nextPageGroupShields.slice(curShieldIndex);
                                    var nextShieldSections = nextShields.reduce(function (acc1, shield) {
                                        var _a, _b, _c, _d, _e, _f;
                                        if (selectedSection.isChanged) {
                                            var sectionsFromSelectedShieldIncluded = shield.id === curShieldId_1 || includeOtherContent;
                                            var includedSections = sectionsFromSelectedShieldIncluded
                                                ? restSelectedShieldSections_1
                                                : {};
                                            var copiedSectionsFromSelectedShield = Object.values(includedSections).reduce(function (acc2, item) {
                                                var _a;
                                                var newSection = createSection({
                                                    targetShield: shield,
                                                    sourceShield: curShield_1,
                                                    sourceSection: item,
                                                });
                                                return __assign(__assign({}, acc2), (_a = {}, _a[newSection.id] = newSection, _a));
                                            }, {});
                                            var value = contentQueue_1.shift();
                                            if (value) {
                                                var newSection = createSection({
                                                    targetShield: shield,
                                                    sourceShield: curShield_1,
                                                    sourceSection: selectedSectionWithoutContent,
                                                });
                                                var updatedSection = __assign(__assign({}, newSection), value);
                                                modified_1.shieldsSelection = (_a = {}, _a[shield.id] = shield, _a);
                                                modified_1.sectionsSelection = (_b = {},
                                                    _b[updatedSection.id] = updatedSection,
                                                    _b);
                                                return __assign(__assign(__assign({}, acc1), (_c = {}, _c[updatedSection.id] = updatedSection, _c)), copiedSectionsFromSelectedShield);
                                            }
                                            return acc1;
                                        }
                                        else {
                                            var value = contentQueue_1.shift();
                                            if (value) {
                                                var newSection = createSectionSmart({
                                                    sourceShield: shield,
                                                    pages: pages,
                                                });
                                                var updatedSection = __assign(__assign(__assign({}, newSection), selectedSectionContentSettings_1), value);
                                                modified_1.shieldsSelection = (_d = {}, _d[shield.id] = shield, _d);
                                                modified_1.sectionsSelection = (_e = {},
                                                    _e[updatedSection.id] = updatedSection,
                                                    _e);
                                                return __assign(__assign({}, acc1), (_f = {}, _f[updatedSection.id] = updatedSection, _f));
                                            }
                                            return acc1;
                                        }
                                    }, {});
                                    var notModifiedPageSections = getNotModifiedPageSections({
                                        modifiedSections: nextShieldSections,
                                        pageSections: nextPage.sections,
                                    }).notModifiedPageSections;
                                    modified_1.pages[nextPage.uid] = __assign(__assign({}, nextPage), { sections: __assign(__assign({}, notModifiedPageSections), nextShieldSections) });
                                    modified_1.pagesOrder.push(nextPage.uid);
                                    modified_1.pageIndex++;
                                }
                                var _d = getUpdatedPagesOrder({
                                    currentPageUid: currentPageUid,
                                    pagesOrder: pagesOrder,
                                    modifiedPagesOrder: modified_1.pagesOrder,
                                }), updatedPagesOrder = _d.updatedPagesOrder, updatedPaginationPageNum = _d.updatedPaginationPageNum, updatedPagesSelection = _d.updatedPagesSelection;
                                dispatch(overridePagesAction({
                                    pages: __assign(__assign({}, pages), modified_1.pages),
                                    pagesOrder: updatedPagesOrder,
                                    shieldsSelection: modified_1.shieldsSelection,
                                    sectionsSelection: modified_1.sectionsSelection,
                                    paginationPageNum: updatedPaginationPageNum,
                                    pagesSelection: updatedPagesSelection,
                                }));
                            }
                            break;
                        }
                        case AUTOFILL_PATTERN.NEXT_PAGE: {
                            var _loop_1 = function () {
                                var _f, _g, _h, _j, _k, _l;
                                var nextPageUid = pagesOrder[modified_1.pageIndex];
                                var nextPage = !!nextPageUid
                                    ? pages[nextPageUid]
                                    : createNewPage();
                                var nextPageGroupShields = Object.values(getShieldsByGroupId({ id: groupId, page: nextPage }));
                                var specificShield = Object.values(nextPageGroupShields).find(function (shield) {
                                    return (shield.primitiveProps.x === curShield_1.primitiveProps.x &&
                                        shield.primitiveProps.y === curShield_1.primitiveProps.y);
                                });
                                var value = contentQueue_1.shift();
                                if (value) {
                                    if (selectedSection.isChanged) {
                                        var newSection = createSection({
                                            targetShield: specificShield,
                                            sourceShield: curShield_1,
                                            sourceSection: selectedSectionWithoutContent,
                                        });
                                        var updatedSection = __assign(__assign(__assign({}, newSection), selectedSectionContentSettings_1), value);
                                        var sectionsFromSelectedShieldIncluded = specificShield.id === curShieldId_1 || includeOtherContent;
                                        var includedSections = sectionsFromSelectedShieldIncluded
                                            ? restSelectedShieldSections_1
                                            : {};
                                        var copiedSectionsFromSelectedShield = Object.values(includedSections).reduce(function (acc2, item) {
                                            var _a;
                                            var newSection = createSection({
                                                targetShield: specificShield,
                                                sourceShield: curShield_1,
                                                sourceSection: item,
                                            });
                                            return __assign(__assign({}, acc2), (_a = {}, _a[newSection.id] = newSection, _a));
                                        }, {});
                                        var notModifiedPageSections = getNotModifiedPageSections({
                                            modifiedSections: copiedSectionsFromSelectedShield,
                                            pageSections: nextPage.sections,
                                        }).notModifiedPageSections;
                                        modified_1.pages[nextPage.uid] = __assign(__assign({}, nextPage), { sections: __assign(__assign(__assign({}, notModifiedPageSections), (_f = {}, _f[updatedSection.id] = updatedSection, _f)), copiedSectionsFromSelectedShield) });
                                        modified_1.shieldsSelection = (_g = {},
                                            _g[specificShield.id] = specificShield,
                                            _g);
                                        modified_1.sectionsSelection = (_h = {},
                                            _h[updatedSection.id] = updatedSection,
                                            _h);
                                    }
                                    else {
                                        var restSections = Object.values(nextPage.sections).reduce(function (acc, section) {
                                            var _a;
                                            if (section.shieldId !== specificShield.id) {
                                                return __assign(__assign({}, acc), (_a = {}, _a[section.id] = section, _a));
                                            }
                                            return acc;
                                        }, {});
                                        var newSection = createSectionSmart({
                                            sourceShield: specificShield,
                                            pages: pages,
                                        });
                                        var updatedSection = __assign(__assign(__assign({}, newSection), selectedSectionContentSettings_1), value);
                                        modified_1.pages[nextPage.uid] = __assign(__assign({}, nextPage), { sections: __assign(__assign({}, restSections), (_j = {}, _j[updatedSection.id] = updatedSection, _j)) });
                                        modified_1.shieldsSelection = (_k = {},
                                            _k[specificShield.id] = specificShield,
                                            _k);
                                        modified_1.sectionsSelection = (_l = {},
                                            _l[updatedSection.id] = updatedSection,
                                            _l);
                                    }
                                }
                                modified_1.pagesOrder.push(nextPage.uid);
                                modified_1.pageIndex++;
                            };
                            while (!!contentQueue_1.length) {
                                _loop_1();
                            }
                            var _e = getUpdatedPagesOrder({
                                currentPageUid: currentPageUid,
                                pagesOrder: pagesOrder,
                                modifiedPagesOrder: modified_1.pagesOrder,
                            }), updatedPagesOrder = _e.updatedPagesOrder, updatedPaginationPageNum = _e.updatedPaginationPageNum, updatedPagesSelection = _e.updatedPagesSelection;
                            dispatch(overridePagesAction({
                                pages: __assign(__assign({}, pages), modified_1.pages),
                                pagesOrder: updatedPagesOrder,
                                shieldsSelection: modified_1.shieldsSelection,
                                sectionsSelection: modified_1.sectionsSelection,
                                paginationPageNum: updatedPaginationPageNum,
                                pagesSelection: updatedPagesSelection,
                            }));
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                    break;
                }
                default: {
                    break;
                }
            }
        }
    };
};
var getLabelsList = function (data) {
    var config = data.config, section = data.section;
    var start = config.start, end = config.end, steps = config.steps, prefix = config.prefix, suffix = config.suffix, isSettingsVisible = config.isSettingsVisible, setting = config.setting, loopsAmount = config.loopsAmount, repeatsAmount = config.repeatsAmount, mode = config.mode, copiesNo = config.copiesNo;
    switch (mode) {
        case AUTOFILL_MODE: {
            return generateListByPattern({
                autofillStart: start,
                autofillEnd: end,
                autofillSteps: steps,
                autofillPrefix: prefix,
                autofillSuffix: suffix,
                isAutofillSettingsVisible: isSettingsVisible,
                autofillSetting: setting,
                loopsAmount: loopsAmount,
                repeatsAmount: repeatsAmount,
            }).map(function (value) { return ({ text: value }); });
        }
        case COPY_MODE: {
            // +1 - because filling includes first shield in handling
            // fill(null) - means copy full section content
            return Array(copiesNo + 1)
                .fill(null)
                .map(function (_) { return Section.getContentWithSettings(section); });
        }
        default: {
            return [];
        }
    }
};
var getSelectedShieldSections = function (payload) {
    var page = payload.page, selectedSection = payload.selectedSection;
    var sections = Object.values(page.sections).reduce(function (acc, item) {
        var _a;
        if (selectedSection.shieldId === item.shieldId) {
            if (selectedSection.id !== item.id) {
                return __assign(__assign({}, acc), (_a = {}, _a[item.id] = item, _a));
            }
        }
        return acc;
    }, {});
    return sections;
};
var getUpdatedPagesOrder = function (payload) {
    var currentPageUid = payload.currentPageUid, pagesOrder = payload.pagesOrder, modifiedPagesOrder = payload.modifiedPagesOrder;
    var updatedPagesOrder = pagesOrder.reduce(function (acc, pageUid) {
        if (acc.includes(pageUid)) {
            return acc;
        }
        else if (pageUid === currentPageUid) {
            return __spreadArray(__spreadArray([], __read(acc), false), __read(modifiedPagesOrder), false);
        }
        return __spreadArray(__spreadArray([], __read(acc), false), [pageUid], false);
    }, []);
    var _a = __read(modifiedPagesOrder.reverse(), 1), lastUpdatedPageUid = _a[0];
    var updatedPaginationPageNum = updatedPagesOrder.findIndex(function (uid) { return uid === lastUpdatedPageUid; }) + 1;
    var updatedPagesSelection = [lastUpdatedPageUid];
    return {
        updatedPagesOrder: updatedPagesOrder,
        updatedPaginationPageNum: updatedPaginationPageNum,
        updatedPagesSelection: updatedPagesSelection,
    };
};
var getNotModifiedPageSections = function (payload) {
    var modifiedSections = payload.modifiedSections, pageSections = payload.pageSections;
    // to identify the changed sections to replace
    var updatedShieldIds = Object.values(modifiedSections).map(function (item) { return item.shieldId; });
    // collect rest page sections
    var notModifiedPageSections = Object.values(pageSections).reduce(function (acc, item) {
        var _a;
        if (!updatedShieldIds.includes(item.shieldId)) {
            return __assign(__assign({}, acc), (_a = {}, _a[item.id] = item, _a));
        }
        return acc;
    }, {});
    return { notModifiedPageSections: notModifiedPageSections };
};
